// 이 파일은 만든 파일이다. 손으로 고치지 말고 scripts/cert-rules/build-rules.ts 로 다시 만든다.
// 원본: recipecat-cert-readiness/research/*.rules.json (규칙마다 1차 출처 URL 과 읽은 날).
import type { CertRuleSource } from './rule-pack'

export const HALAL_RULE_SOURCES: CertRuleSource[] = [
  {
    id: 'H-MKT-01',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['documents', 'label'],
    source: [
      'https://www.halal.gov.my/pdf/cb/FHCB21August2026.pdf',
      'https://berita.rtm.gov.my/highlights/senarai-berita-highlights/senarai-artikel/jakim-recognises-five-additional-foreign-halal-certification-bodies/',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-MKT-06',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['ingredient', 'facility', 'documents'],
    source: ['https://www.halal.gov.my/pdf/cb/FHCB21August2026.pdf'],
    readDate: '2026-11-01',
  },
  {
    id: 'H-MKT-02',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['documents', 'label'],
    source: [
      'https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm',
      'https://bpjph.halal.go.id/read/penegasan-bpjph-di-sidang-wto-dari-produk-nonhalal-dapat-diimpor-hingga-skema-registrasi-halal-luar-negeri',
      'https://bpjph.halal.go.id/read/hari-kedua-h-20-2023-bpjph-teken-mra-dengan-37-lembaga-halal-luar-negeri',
      'https://cmsbl.halal.go.id/uploads/Keputusan_Kepala_Badan_No_221_Tahun_2025_Tentang_Prosedur_Pelaksanaan_Registrasi_Sertifikat_Halal_Luar_Negeri_886d63c7b5.pdf',
      'https://jdih.halal.go.id/dokumen/ccbd84f4-14f5-47a6-8b91-7d6ae1333c75',
      'https://www.ekon.go.id/publikasi/detail/7161/pemerintah-sesuaikan-masa-penahapan-kewajiban-bersertifikat-halal-dengan-memperhatikan-kesiapan-ekosistem-dan-pemangku-kepentingan',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-MKT-03',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['label'],
    source: [
      'https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm',
      'https://bpjph.halal.go.id/read/penegasan-bpjph-di-sidang-wto-dari-produk-nonhalal-dapat-diimpor-hingga-skema-registrasi-halal-luar-negeri',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-MKT-04',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['documents'],
    source: [
      'https://moiat.gov.ae/en/programs/halal',
      'https://moiat.gov.ae/en/programs/halal/registered-halal-certification-bodies',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-MKT-05',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['ingredient', 'additive', 'documents'],
    source: ['https://moiat.gov.ae/en/programs/halal'],
    readDate: '2026-11-01',
  },
  {
    id: 'H-ING-01',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['ingredient', 'additive'],
    source: [
      'https://www.fao.org/input/download/standards/352/CXG_024e.pdf',
      'https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-ING-02',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['ingredient'],
    source: [
      'https://www.fao.org/input/download/standards/352/CXG_024e.pdf',
      'https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-ING-03',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['ingredient'],
    source: ['https://www.fao.org/input/download/standards/352/CXG_024e.pdf'],
    readDate: '2026-11-01',
  },
  {
    id: 'H-ING-04',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['ingredient'],
    source: [
      'https://www.fao.org/input/download/standards/352/CXG_024e.pdf',
      'https://fatwamui.com/storage/138/Fatwa-MUI-No.-10-Tahun-2018-tentang-Makanan-dan-Minuman-Mengandung-Alkohol.pdf',
      'https://www.muftiwp.gov.my/en/artikel/irsyad-fatwa/irsyad-fatwa-umum-cat/3097-irsyad-al-fatwa-siri-ke-290-hukum-pewarna-makanan-20-peratus-alkohol',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-ING-05',
    severity: '불합격',
    autoCheck: '사람 확인',
    appliesTo: ['ingredient'],
    source: [
      'https://www.fao.org/input/download/standards/352/CXG_024e.pdf',
      'https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-ING-06',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['ingredient', 'documents'],
    source: [
      'https://www.fao.org/input/download/standards/352/CXG_024e.pdf',
      'https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-SLA-01',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['ingredient', 'process', 'documents'],
    source: [
      'https://www.fao.org/input/download/standards/352/CXG_024e.pdf',
      'https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-ALC-01',
    severity: '경고',
    autoCheck: '사람 확인',
    appliesTo: ['ingredient', 'additive', 'documents'],
    source: [
      'https://fatwamui.com/storage/138/Fatwa-MUI-No.-10-Tahun-2018-tentang-Makanan-dan-Minuman-Mengandung-Alkohol.pdf',
      'https://halalmui.org/memahami-fatwa-mui-tentang-kadar-etanol-pada-produk-makanan-dan-minuman/',
      'https://www.muftiwp.gov.my/en/artikel/irsyad-fatwa/irsyad-fatwa-umum-cat/3097-irsyad-al-fatwa-siri-ke-290-hukum-pewarna-makanan-20-peratus-alkohol',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-ALC-02',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['ingredient', 'CCP', 'documents'],
    source: [
      'https://fatwamui.com/storage/138/Fatwa-MUI-No.-10-Tahun-2018-tentang-Makanan-dan-Minuman-Mengandung-Alkohol.pdf',
      'https://www.muftiwp.gov.my/en/artikel/irsyad-fatwa/irsyad-fatwa-umum-cat/3097-irsyad-al-fatwa-siri-ke-290-hukum-pewarna-makanan-20-peratus-alkohol',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-ALC-03',
    severity: '경고',
    autoCheck: '자동',
    appliesTo: ['ingredient', 'process'],
    source: [
      'https://fatwamui.com/storage/138/Fatwa-MUI-No.-10-Tahun-2018-tentang-Makanan-dan-Minuman-Mengandung-Alkohol.pdf',
      'https://www.muftiwp.gov.my/en/artikel/irsyad-fatwa/irsyad-fatwa-umum-cat/3097-irsyad-al-fatwa-siri-ke-290-hukum-pewarna-makanan-20-peratus-alkohol',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-ALC-04',
    severity: '경고',
    autoCheck: '사람 확인',
    appliesTo: ['ingredient'],
    source: [
      'https://fatwamui.com/storage/138/Fatwa-MUI-No.-10-Tahun-2018-tentang-Makanan-dan-Minuman-Mengandung-Alkohol.pdf',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-SRC-01',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['ingredient', 'additive', 'documents'],
    source: [
      'https://halalmui.org/bahas-yang-lagi-viral-kenapa-es-krim-harus-sertifikasi-halal/',
      'https://www.fao.org/input/download/standards/352/CXG_024e.pdf',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-SRC-02',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['additive', 'ingredient', 'documents'],
    source: [
      'https://halalmui.org/bahas-yang-lagi-viral-kenapa-es-krim-harus-sertifikasi-halal/',
      'https://www.fao.org/input/download/standards/352/CXG_024e.pdf',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-SRC-03',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['ingredient', 'additive', 'documents'],
    source: ['https://halalmui.org/bahas-yang-lagi-viral-kenapa-es-krim-harus-sertifikasi-halal/'],
    readDate: '2026-11-01',
  },
  {
    id: 'H-SRC-04',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['additive', 'documents'],
    source: [
      'https://halalmui.org/bahas-yang-lagi-viral-kenapa-es-krim-harus-sertifikasi-halal/',
      'https://fatwamui.com/storage/138/Fatwa-MUI-No.-10-Tahun-2018-tentang-Makanan-dan-Minuman-Mengandung-Alkohol.pdf',
      'https://www.muftiwp.gov.my/en/artikel/irsyad-fatwa/irsyad-fatwa-umum-cat/3097-irsyad-al-fatwa-siri-ke-290-hukum-pewarna-makanan-20-peratus-alkohol',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-SRC-05',
    severity: '경고',
    autoCheck: '공장 서류 필요',
    appliesTo: ['ingredient', 'documents'],
    source: ['https://halalmui.org/bahas-yang-lagi-viral-kenapa-es-krim-harus-sertifikasi-halal/'],
    readDate: '2026-11-01',
  },
  {
    id: 'H-SRC-06',
    severity: '경고',
    autoCheck: '공장 서류 필요',
    appliesTo: ['additive', 'ingredient', 'documents'],
    source: ['https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm'],
    readDate: '2026-11-01',
  },
  {
    id: 'H-SRC-07',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['ingredient', 'documents'],
    source: [
      'https://halalmui.org/bukan-sekedar-izin-3-hal-ini-wajib-ada-di-sertifikasi-halal/',
      'https://bpjph.halal.go.id/read/penting-diketahui-ini-bahan-yang-dikecualikan-dari-kewajiban-bersertifikat-halal',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-SRC-08',
    severity: '경고',
    autoCheck: '자동',
    appliesTo: ['ingredient', 'documents'],
    source: [
      'https://bpjph.halal.go.id/read/penting-diketahui-ini-bahan-yang-dikecualikan-dari-kewajiban-bersertifikat-halal',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-PRC-01',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['process', 'facility'],
    source: [
      'https://www.fao.org/input/download/standards/352/CXG_024e.pdf',
      'https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm',
      'https://halalmui.org/ketepatan-waktu-dan-kualitas-layanan-strategi-lph-lppom-hadapi-tantangan-sertifikasi-halal/',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-PRC-02',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['process', 'CCP', 'facility', 'documents'],
    source: [
      'https://www.fao.org/input/download/standards/352/CXG_024e.pdf',
      'https://muftiwp.gov.my/en/artikel/al-kafi-li-al-fatawi/3545-al-kafi-1316-the-difference-between-sertu-and-samak',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-PRC-03',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['facility', 'documents'],
    source: [
      'https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm',
      'https://halalmui.org/bukan-sekedar-izin-3-hal-ini-wajib-ada-di-sertifikasi-halal/',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-PRC-04',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['additive', 'process', 'documents'],
    source: [
      'https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm',
      'https://www.fao.org/input/download/standards/352/CXG_024e.pdf',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-PKG-01',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['packaging'],
    source: [
      'https://www.fao.org/input/download/standards/352/CXG_024e.pdf',
      'https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-STO-01',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['storage'],
    source: [
      'https://www.fao.org/input/download/standards/352/CXG_024e.pdf',
      'https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-LBL-01',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['label'],
    source: [
      'https://www.fao.org/input/download/standards/352/CXG_024e.pdf',
      'https://www.halal.gov.my/pdf/cb/FHCB21August2026.pdf',
      'https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-LBL-02',
    severity: '보완',
    autoCheck: '자동',
    appliesTo: ['label'],
    source: ['https://www.fao.org/input/download/standards/352/CXG_024e.pdf'],
    readDate: '2026-11-01',
  },
  {
    id: 'H-LBL-03',
    severity: '보완',
    autoCheck: '자동',
    appliesTo: ['label'],
    source: [
      'https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm',
      'https://bpjph.halal.go.id/read/penegasan-bpjph-di-sidang-wto-dari-produk-nonhalal-dapat-diimpor-hingga-skema-registrasi-halal-luar-negeri',
      'https://cmsbl.halal.go.id/uploads/Keputusan_Kepala_Badan_No_221_Tahun_2025_Tentang_Prosedur_Pelaksanaan_Registrasi_Sertifikat_Halal_Luar_Negeri_886d63c7b5.pdf',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-LBL-04',
    severity: '보완',
    autoCheck: '자동',
    appliesTo: ['label'],
    source: ['https://www.halal.gov.my/pdf/cb/FHCB21August2026.pdf'],
    readDate: '2026-11-01',
  },
  {
    id: 'H-DOC-01',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['documents', 'ingredient'],
    source: ['https://halalmui.org/bukan-sekedar-izin-3-hal-ini-wajib-ada-di-sertifikasi-halal/'],
    readDate: '2026-11-01',
  },
  {
    id: 'H-DOC-02',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['facility', 'documents'],
    source: [
      'https://halalmui.org/bukan-sekedar-izin-3-hal-ini-wajib-ada-di-sertifikasi-halal/',
      'https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-DOC-03',
    severity: '보완',
    autoCheck: '자동',
    appliesTo: ['ingredient', 'documents'],
    source: [
      'https://jdih.kemenkeu.go.id/api/download/fulltext/2014/33TAHUN2014UU.htm',
      'https://jateng.kemenag.go.id/perpu-ciptaker-bpjph-sertifikasi-halal-bagi-umk-lebih-cepat/',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-DOC-04',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['facility', 'documents', 'label'],
    source: ['https://haikorea.org/halalcertification'],
    readDate: '2026-11-01',
    internalRefs: 1,
  },
  {
    id: 'H-DOC-05',
    severity: '보완',
    autoCheck: '사람 확인',
    appliesTo: ['ingredient', 'documents'],
    source: [
      'https://halalmui.org/ketepatan-waktu-dan-kualitas-layanan-strategi-lph-lppom-hadapi-tantangan-sertifikasi-halal/',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'H-DOC-06',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['documents'],
    source: [
      'https://haikorea.org/halalcertification',
      'https://jateng.kemenag.go.id/perpu-ciptaker-bpjph-sertifikasi-halal-bagi-umk-lebih-cepat/',
      'https://cmsbl.halal.go.id/uploads/Keputusan_Kepala_Badan_No_221_Tahun_2025_Tentang_Prosedur_Pelaksanaan_Registrasi_Sertifikat_Halal_Luar_Negeri_886d63c7b5.pdf',
    ],
    readDate: '2026-11-01',
    internalRefs: 1,
  },
]

export const HACCP_RULE_SOURCES: CertRuleSource[] = [
  {
    id: 'HK-SCOPE-01',
    severity: '경고',
    autoCheck: '자동',
    appliesTo: ['facility', 'documents'],
    source: [
      'https://www.law.go.kr/LSW//lsLawLinkInfo.do?lsJoLnkSeq=1000608556&lsId=007634&chrClsCd=010202&print=print',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-SCOPE-02',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['facility'],
    source: [
      'https://www.law.go.kr/LSW//lsLawLinkInfo.do?lsJoLnkSeq=1000608556&lsId=007634&chrClsCd=010202&print=print',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-SCOPE-03',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['facility', 'documents'],
    source: [
      'https://www.law.go.kr/LSW/lsPdfPrint.do?ancYnChk=0&lsiSeq=285339&efYd=20261008&efGubun=Y&joAllCheck=Y&joEfOutPutYn=on&mokChaChk=N&bylChaChk=N',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-SCOPE-04',
    severity: '경고',
    autoCheck: '사람 확인',
    appliesTo: ['facility'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-SCOPE-05',
    severity: '경고',
    autoCheck: '사람 확인',
    appliesTo: ['facility'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-SCOPE-06',
    severity: '경고',
    autoCheck: '자동',
    appliesTo: ['facility'],
    source: [
      'https://www.law.go.kr/LSW/lsPdfPrint.do?ancYnChk=0&lsiSeq=288709&efYd=20260811&efGubun=Y&joAllCheck=Y&joEfOutPutYn=on&mokChaChk=N&bylChaChk=N',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-SCOPE-07',
    severity: '경고',
    autoCheck: '자동',
    appliesTo: ['process', 'packaging', 'storage'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=16',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-SCOPE-08',
    severity: '경고',
    autoCheck: '사람 확인',
    appliesTo: ['facility'],
    source: ['https://www.korea.kr/briefing/pressReleaseView.do?newsId=156742473'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-01',
    severity: '경고',
    autoCheck: '공장 서류 필요',
    appliesTo: ['facility', 'documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-02',
    severity: '보완',
    autoCheck: '사람 확인',
    appliesTo: ['facility'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-03',
    severity: '보완',
    autoCheck: '사람 확인',
    appliesTo: ['facility'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-04',
    severity: '보완',
    autoCheck: '사람 확인',
    appliesTo: ['facility'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-05',
    severity: '보완',
    autoCheck: '사람 확인',
    appliesTo: ['facility'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-06',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['documents', 'facility'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-07',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['CCP', 'facility', 'documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-08',
    severity: '보완',
    autoCheck: '자동',
    appliesTo: ['storage', 'facility'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-09',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['facility', 'documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-10',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['ingredient', 'facility', 'documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-11',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['facility', 'documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-12',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['ingredient', 'documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-13',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['ingredient', 'documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-14',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['storage'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-15',
    severity: '보완',
    autoCheck: '사람 확인',
    appliesTo: ['storage', 'facility'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-16',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-17',
    severity: '보완',
    autoCheck: '자동',
    appliesTo: ['label', 'documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PRP-18',
    severity: '보완',
    autoCheck: '사람 확인',
    appliesTo: ['process', 'CCP'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PLAN-01',
    severity: '경고',
    autoCheck: '자동',
    appliesTo: ['documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PLAN-02',
    severity: '보완',
    autoCheck: '자동',
    appliesTo: ['documents', 'ingredient', 'packaging', 'storage'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PLAN-03',
    severity: '보완',
    autoCheck: '사람 확인',
    appliesTo: ['ingredient', 'process'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PLAN-04',
    severity: '불합격',
    autoCheck: '사람 확인',
    appliesTo: ['CCP'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PLAN-05',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['CCP', 'process'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PLAN-06',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['CCP', 'documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PLAN-07',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['CCP', 'documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PLAN-08',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PLAN-09',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PLAN-10',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['facility', 'documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PLAN-11',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-PLAN-12',
    severity: '경고',
    autoCheck: '자동',
    appliesTo: ['ingredient', 'process'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-CCP-01',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['process', 'CCP'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=10',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-CCP-02',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['process', 'CCP'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=10',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-CCP-03',
    severity: '경고',
    autoCheck: '자동',
    appliesTo: ['process', 'CCP'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=10',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-CCP-04',
    severity: '보완',
    autoCheck: '자동',
    appliesTo: ['label', 'documents'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=16',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-CCP-05',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['additive'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=16',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-CCP-06',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['process', 'CCP'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=10',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-CCP-07',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['process', 'CCP'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=12',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-CCP-08',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['process', 'CCP'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=10',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-CCP-09',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['CCP', 'documents'],
    source: ['https://www.mfds.go.kr/brd/m_861/view.do?seq=30792'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-CCP-10',
    severity: '경고',
    autoCheck: '자동',
    appliesTo: ['process'],
    source: ['https://www.mfds.go.kr/brd/m_861/view.do?seq=30792'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-CCP-11',
    severity: '보완',
    autoCheck: '자동',
    appliesTo: ['process'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=10',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-CCP-12',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['packaging'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=10',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-STO-01',
    severity: '보완',
    autoCheck: '자동',
    appliesTo: ['storage', 'label'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=13',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-STO-02',
    severity: '경고',
    autoCheck: '자동',
    appliesTo: ['storage'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=13',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-STO-03',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['storage', 'label'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=13',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-STO-04',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['storage'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=13',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-STD-01',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['additive'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=32',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-STD-02',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['additive'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=32',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-STD-03',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['ingredient'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=32',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-STD-04',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['additive'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=32',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-STD-05',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['ingredient'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=32',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-STD-06',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['additive'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=32',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-STD-07',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['additive', 'process'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=33',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-STD-08',
    severity: '경고',
    autoCheck: '자동',
    appliesTo: ['additive'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=32',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-STD-09',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['additive', 'ingredient'],
    source: [
      'https://www.foodsafetykorea.go.kr/popup/safefoodlife/food/foodRvlv/foodRvlvDetail.do?rvlv_no=33',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-AUD-01',
    severity: '경고',
    autoCheck: '공장 서류 필요',
    appliesTo: ['documents'],
    source: [
      'https://www.law.go.kr/LSW/lsPdfPrint.do?ancYnChk=0&lsiSeq=289161&efYd=20260901&efGubun=Y&joAllCheck=Y&joEfOutPutYn=on&mokChaChk=N&bylChaChk=N',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-AUD-02',
    severity: '보완',
    autoCheck: '사람 확인',
    appliesTo: ['documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-AUD-03',
    severity: '불합격',
    autoCheck: '사람 확인',
    appliesTo: ['documents', 'facility'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-AUD-04',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['documents'],
    source: [
      'https://www.law.go.kr/LSW/lsPdfPrint.do?ancYnChk=0&lsiSeq=289161&efYd=20260901&efGubun=Y&joAllCheck=Y&joEfOutPutYn=on&mokChaChk=N&bylChaChk=N',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-AUD-05',
    severity: '경고',
    autoCheck: '공장 서류 필요',
    appliesTo: ['documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-AUD-06',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['facility'],
    source: [
      'https://www.law.go.kr/LSW/lsPdfPrint.do?ancYnChk=0&lsiSeq=285339&efYd=20261008&efGubun=Y&joAllCheck=Y&joEfOutPutYn=on&mokChaChk=N&bylChaChk=N',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-AUD-07',
    severity: '보완',
    autoCheck: '공장 서류 필요',
    appliesTo: ['process', 'CCP', 'facility'],
    source: [
      'https://www.law.go.kr/LSW/lsPdfPrint.do?ancYnChk=0&lsiSeq=289161&efYd=20260901&efGubun=Y&joAllCheck=Y&joEfOutPutYn=on&mokChaChk=N&bylChaChk=N',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-AUD-08',
    severity: '경고',
    autoCheck: '사람 확인',
    appliesTo: ['documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-AUD-09',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-LBL-01',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['label'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-LBL-02',
    severity: '불합격',
    autoCheck: '자동',
    appliesTo: ['label'],
    source: [
      'https://www.law.go.kr/LSW/lsPdfPrint.do?ancYnChk=0&lsiSeq=285339&efYd=20261008&efGubun=Y&joAllCheck=Y&joEfOutPutYn=on&mokChaChk=N&bylChaChk=N',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-LBL-03',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['label'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-OEM-01',
    severity: '불합격',
    autoCheck: '공장 서류 필요',
    appliesTo: ['facility'],
    source: [
      'https://www.law.go.kr/LSW/lsPdfPrint.do?ancYnChk=0&lsiSeq=285339&efYd=20261008&efGubun=Y&joAllCheck=Y&joEfOutPutYn=on&mokChaChk=N&bylChaChk=N',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-SUP-01',
    severity: '경고',
    autoCheck: '사람 확인',
    appliesTo: ['facility'],
    source: [
      'https://www.law.go.kr/LSW/lsPdfPrint.do?ancYnChk=0&lsiSeq=289161&efYd=20260901&efGubun=Y&joAllCheck=Y&joEfOutPutYn=on&mokChaChk=N&bylChaChk=N',
    ],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-SUP-02',
    severity: '경고',
    autoCheck: '사람 확인',
    appliesTo: ['facility'],
    source: ['https://www.korea.kr/briefing/pressReleaseView.do?newsId=156742473'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-SUP-03',
    severity: '경고',
    autoCheck: '사람 확인',
    appliesTo: ['facility'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
  {
    id: 'HK-GH-01',
    severity: '경고',
    autoCheck: '사람 확인',
    appliesTo: ['label', 'documents'],
    source: ['https://www.law.go.kr/LSW/flDownload.do?flSeq=168133311'],
    readDate: '2026-11-01',
  },
]
